import { walkFormConfig } from '@mes-amis/super-form';
import type { SuperFormDefinition } from '@mes-amis/super-form';

export interface RelationshipOption {
  label: string;
  value: string;
}

/**
 * Relationship choices for the Add/Edit Contact modal. The server ships them
 * on every Contact selector field in the template config (`enum_options`), so
 * we read them back off the definition rather than duplicating the enum here.
 */
export function contactRelationshipOptions(definition?: SuperFormDefinition | null): RelationshipOption[] {
  let options: RelationshipOption[] = [];

  walkFormConfig(definition?.form, ({ config }) => {
    if (options.length || config?.model !== 'Contact') return;

    const relationships = config.enum_options?.relationship;
    if (relationships?.length) options = relationships;
  });

  return options;
}
